if (!customElements.get('ly-learn-more-showrooms')) {
    customElements.define('ly-learn-more-showrooms', class extends HTMLElement {

        #index = 0
        #last = 0

        connectedCallback() {
            this.bgsWrapper = this.querySelector('[data-bgs]')
            this.bgs = [...this.bgsWrapper.querySelectorAll('[data-bg]')]
            this.cardsWrapper = this.querySelector('[data-cards]')
            this.cards = [...this.cardsWrapper.querySelectorAll('[data-card]')]

            this.#last = this.cards.length - 1

            this.preBtn = this.querySelector('[data-prev]')
            this.nextBtn = this.querySelector('[data-next]')
            this.carousel = this.querySelector('ly-learn-more-showrooms-thumbnails-carousel')

            this.addEventListener('index_changed', this.handleIndexChange)

            this.preBtn.addEventListener('click', this.handlePrev)
            this.nextBtn.addEventListener('click', this.handleNext)
        }

        disconnectedCallback() {
            this.removeEventListener('index_changed', this.handleIndexChange)

            this.preBtn.removeEventListener('click', this.handlePrev)
            this.nextBtn.removeEventListener('click', this.handleNext)
        }

        handleIndexChange = (evt) => {
            this.#index = evt.detail.index

            this.updateStatus()
        }

        updateStatus = () => {
            this.updateTransform(this.bgsWrapper)
            this.updateActiveEl(this.bgs)
            this.updateTransform(this.cardsWrapper)
            this.updateActiveEl(this.cards)

            this.updateBtnStatus()
        }

        updateTransform = el => {
            el.style.transform = `translateX(-${this.#index * 100}%)`
        }

        updateActiveEl = (els) => {
            els.forEach((el, index) => {
                el.classList.toggle('is-active', this.#index === index)
            })
        }

        updateBtnStatus = () => {
            this.preBtn.disabled = this.#index <= 0
            this.nextBtn.disabled = this.#index >= this.#last
        }

        handlePrev = () => {
            if (this.#index <= 0) return
            this.carousel._index -= 1
        }

        handleNext = () => {
            if (this.#index >= this.#last) return
            this.carousel._index += 1
        }
    })
}

if (!customElements.get('ly-learn-more-showrooms-thumbnails-carousel')) {
    customElements.define('ly-learn-more-showrooms-thumbnails-carousel', class extends LyPartScrollCarousel {

        connectedCallback() {
            super.connectedCallback()

            this.removeItemClickEvents = this.addItemClickEvents()
        }

        disconnectedCallback() {
            this.removeItemClickEvents?.()

            super.disconnectedCallback()
        }


        addItemClickEvents = () => {
            const removeHandlers = []
            this._items.forEach((item, index) => {
                const handler = () => this._index = index
                item.addEventListener('click', handler)
                removeHandlers.push(() => item.removeEventListener('click', handler))
            })
            return () => removeHandlers.forEach(h => h())
        }

        _onIndexChanged = (index) => {
            this.dispatchEvent(new CustomEvent('index_changed', {
                bubbles: true,
                detail: {
                    index
                }
            }))
        }
    })
}